module.exports = __webpack_public_path__ + "img/ic-success.f1c5fab8.svg";